import { GalleryExportService } from './../../../services/gallery-export-service.ts.service';
import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import {
  ExportDataDialogService, IDataExportContext,
  ExportDialogShowParams, ExportTypeOptionsDict, ExportContentOptionsDict,
  ExportableColumnOptionDict,
  ExportableColumnOption,
  ExportContentOption,
  ExportTypeOption
} from './export-data-dialog-service.';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { MapIOOptions } from 'src/app/model/api-services/map-api.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { EnvService } from 'src/app/env.service';
import { Dict } from 'src/app/types/decorable';
import { XLSExportService } from 'src/app/services/xls-export.service';
import { ShpExportService } from 'src/app/services/shp-export-service';
import { SLLayer } from 'src/app/model/sl-layer';
import { KmlExportService } from 'src/app/services/kml-export-service';
import { CsvExportService } from 'src/app/services/csv-export.service';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { ExcelIoService } from 'src/app/services/io/excel-io.service';
import { SlWapiService } from 'src/app/model/api-services/sl-wapi.service';

@Component({
  selector: 'app-export-data-dialog',
  templateUrl: './export-data-dialog.component.html',
  styleUrls: ['./export-data-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportDataDialogComponent implements OnInit {
  title = 'Export Data ...';
  private params: ExportDialogShowParams = null;
  private context: IDataExportContext = null;
  private srses: Dict = {};
  public isCastable = false;
  public isProjectable = false;

  public options: MapIOOptions = {
    location: true,
    layerOrder: true,
    layerSettings: true,
    baseMap: true,
    ThreeD: true,
    selectionStyles: true,
    asNew: {
      on: false,
      name: '',
      openAfter: true
    }
  };
  public type: ExportTypeOption = null;
  public content: ExportContentOption = null;
  public columns: ExportableColumnOption = null;
  public reporting: 'casted' | 'raw' | '' = '';
  public projection: 'layer' | 'web' | 'latlon' | 'authcode' | 'prj-name' | 'prj-file' | 'prj' = null;
  // tslint:disable-next-line: variable-name
  public authCode_auth: 'epsg' | 'esri' | '' = '';
  // tslint:disable-next-line: variable-name
  public authCode_code = '';
  public projectionOptions = [];
  public hasTypeOptions = false;
  public hasContentOptions = false;
  public hasColumnOptions = false;
  public srsText = '';
  public typeOptions: ExportTypeOptionsDict = {};
  public contentOptions: ExportContentOptionsDict = {};
  public columnOptions: ExportableColumnOptionDict = {};
  public includeMapImage = true;
  public isCapturable = false;
  public needProjectionSel = false;
  private map: ISLMap;
  @HostBinding('class.work-view') workView = true;

  constructor(private activeModal: NgbActiveModal,
    private domNode: ElementRef, private messager: ModalMessagerService,
    private env: EnvService, private changes: ChangeDetectorRef,
    private xls: ExcelIoService,
    private shp: ShpExportService,
    private kmz: KmlExportService,
    private csv: CsvExportService,
    private galleryExporter:GalleryExportService,
    private layerAPI: LayerApiService) { }

  ngOnInit() {
    $(this.domNode.nativeElement).prev('.modal-dialog').toggleClass('modal-overflow');
  }
  Show(params: ExportDialogShowParams) {
    this.params = params;
    this.context = this.params.params.context;
    const map = this.context.GetMap();
    this.srses = map.GetUsedSRSes();
    const keys = Object.keys(this.srses);
    this.projectionOptions = keys.sort();

    this.typeOptions = this.context.GetTypeOptions();
    this.hasTypeOptions = Object.keys(this.typeOptions).length > 0;
    this.contentOptions = [];
    this.hasContentOptions = false;
    /*this.contentOptions = this.context.GetContentOptions(this.type);
    this.hasContentOptions = Object.keys(this.contentOptions).length > 0;
    */
    this.columnOptions = this.context.GetColumnExportOptions();
    this.hasColumnOptions = Object.keys(this.columnOptions).length > 0;
    // this.options.asNew.name = 'Copy of ' + params.map.project.name;
    // this.map = params.map;
    this.changes.detectChanges();
  }
  HandleTypeChange(event: any) {
    const sel: HTMLSelectElement = event.target;
    const value = sel.value;
    this.isCapturable = false;
    switch (value) {
      case 'xls':
        this.isCastable = true;
        this.isProjectable = false;
        this.isCapturable = true;
        this.reporting = this.context.GetRawMode() ? 'raw' : 'casted';
        break;
      case 'csv':
        this.isCastable = true;
        this.isProjectable = false;
        break;
      case 'kmz':
        this.isCastable = false;
        this.isProjectable = false;
        break;
      case 'shp':
        this.isCastable = false;
        this.isProjectable = true;
        break;
      case 'gallery':
        this.isCastable = false;
        this.isProjectable = false;
        break;
    }
    this.changes.detectChanges();
    this.contentOptions = this.context.GetContentOptions(this.type);
    this.hasContentOptions = Object.keys(this.contentOptions).length > 0;
    this.needProjectionSel = this.isProjectable && (this.projection === 'prj');
    this.changes.detectChanges();
  }
  HandleContentChange(event: any) {

  }
  HandleColumnsChange(event: any) {

  }
  HandleReportingChange(event: any) {

  }
  HandleProjectionChange(event: any) {
    this.needProjectionSel = this.isProjectable && (this.projection === 'prj');
    this.changes.detectChanges();
  }

  SaveMemory(): void {
    this.layerAPI.SearchFeatures(
      {
        idField: 'gid',
        layer: this.map.memory.layer.id,
        filters: '[{"compare":"IN","value":"' + this.map.memory.features.join(',') + '","field":"gid"}]'

      }).then((response) => {
        this.messager.Progress('Features retrieved ... processing data', false, null, 'Retrieving data');
        window.requestAnimationFrame(() => {
          this.messager.CancelProgress('Retrieving data');
          if (!response.results || response.results.length === 0) {
            this.messager.Notify('There was a problem retrieving remembered features for export');
          }
          const columnDefs = [];
          const exportData = response.results[0].features;
          const cols = this.map.memory.layer.GetExportableAttributes(this.columns === 'visible');
          this.Save(this.map.memory.layer, exportData, cols);
          // CsvExportService.ExportData(this.messager, columnDefs, this.map.memory.layer, exportData, this.rawMode);
        })

      });
  }

  Save(useLayer: SLLayer = null, useData: any = null, useCols?: Array<string>): void {
    /*const params = {
      type: (this.type),
      content: this.content,
      columns: this.columns,
      reporting: this.reporting,
      projection: this.projection
    };*/
    if (this.content === 'mem' && useLayer === null) {
      this.SaveMemory();
    }
    const columns = (!!useCols) ? useCols : this.context.GetExportableColumns(this.columns);
    const layer: SLLayer = (!!useLayer) ? useLayer : this.context.GetSLLayer();
    const data = this.context.GetExportData(this.type, this.content, useData) as Array<any>;
    switch (this.type) {
      case 'csv':
        {
          CsvExportService.ExportData(this.messager,
            this.context.GetExportableColumns(this.columns),
            layer,
            data as Array<any>,
            this.reporting === 'raw'
          );
        }
        break;
      case 'kmz':
        {
          this.kmz.ExportKMZ(
            this.messager,
            layer.name,
            layer,
            this.context.GetExportableColumns(this.columns),
            this.context.GetExportData(this.type, this.content) as Array<any>,
            true);
        }
        break;
      case 'shp':
        {
          this.shp.ExportSHP(
            this.messager,
            layer.name,
            layer,
            this.context.GetExportableColumns(this.columns),
            this.context.GetExportData(this.type, this.content) as Array<any>,
            true,
            this.GetProjection());
        }
        break;
      case 'xls':
        {
          if (!this.context.GetMetaProvider) {
            this.context.GetMetaProvider = () => { return null; };
          }
          ExcelIoService.ExportData(
            this.messager, data, columns, layer,
            this.context.GetMetaProvider(),
            this.reporting === 'raw', this.includeMapImage, this.context.HasGroupings() || this.context.HasSummaries());
          /*XLSExportService.ExportData(this.messager, columns, layer,
            this.context.GetMetaProvider, data as Array<any>, this.reporting === 'raw');
            */
        }
        break;
      case 'gallery':
        const ids = [];

        this.galleryExporter.ExportGallery(this.messager,'Results_Media_Gallery_'+layer.name,layer,columns,data,()=>{
          this.activeModal.close();
        })
        break;
    }

    /*this.messager.Progress('Sending map info to server', false, .5, 'Saving Map Info');
    this.map.Save(this.options).then((response) => {
      if (!(!!response)) {
        return;
      }
      this.messager.Progress('Data sent to server, processing response', false, .75, 'Saving Map Info');
      if (!!response.message) {
        this.messager.Progress('', true, 1, 'Saving Map Info');
        this.messager.CancelProgress('Saving Map Info');
        this.messager.Notify(response.message.split(':').pop(), true, 'A problem was encountered');
        return;
      }
      if (!!response.openAfter) {
        if (response.openAfter === 1) {
          window.open(this.env.GetAppURL() + response.mapId, '_blank');
          this.messager.Progress(
            'Complete; Your new map id is '
            + response.mapId
            + ', it has been open in another window/tab',
            true, 1, 'Saving Map Info');
        } else {
          this.messager.Progress(
            'Complete; Your new map id is '
            + response.mapId,
            true, 1, 'Saving Map Info');
        }
      } else {
        this.messager.Progress(
          'Complete, the map changes you specified have been saved',
          true, 1, 'Saving Map Info');
      }
      this.activeModal.close();

    });
    */
  }
  Cancel(): void {
    this.activeModal.close();
  }
  GetProjection() {
    switch (this.projection) {
      case 'layer':
        return {
          srs: 'layer'
        }
        break;
      case 'web':
        return {
          srs: 'web'
        }
        break;
      case 'prj':
        return {
          srs: 'prj',
          prj: this.srsText
        }
        break;
      default:
        if (!!this.srses[this.projection]) {
          return {
            srs: 'prj',
            prj: this.srses[this.projection]
          }
        }
        return {};
    }
  }
}

@Component({
  selector: 'app-export-data-dialog-entry',
  template: ''
})
export class ExportDataDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: ExportDataDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(ExportDataDialogComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as ExportDataDialogComponent).Show(info);
    });
  }
  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }

}


